import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { useIsDesktop } from 'Hooks';
import { Buttons } from './Buttons';
import { CloseSearch } from './CloseSearch';
import { DateFields } from './DateFields';
import { SearchFields } from './SearchFields';
import { PurpleClose } from 'Images';

interface IAdvancedSearchPanel {
  dispatchReferrals: Function;
  closeAdvancedSearch: Function;
}

export const AdvancedSearchPanel = ({
  dispatchReferrals,
  closeAdvancedSearch,
}: IAdvancedSearchPanel) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      zIndex={isDesktop ? 1 : 1500}
      position={isDesktop ? 'relative' : 'fixed'}
      bgcolor={isDesktop ? 'primary.shade_100' : '#fff'}
      borderRadius={isDesktop ? '16px 0 16px 16px' : '0'}
      padding={isDesktop ? '32px 40px 40px' : '24px'}
      sx={
        isDesktop
          ? {
              filter: 'drop-shadow(0px 2px 16px rgba(4, 16, 46, 0.08))',
            }
          : { height: '100vh', top: 0, left: 0, overflow: 'auto' }
      }
      role='alertdialog'
      aria-modal='true'
    >
      {!isDesktop && (
        <>
          <Avatar
            alt={
              Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch
                .close
            }
            src={PurpleClose}
            sx={{ margin: '0 0 0 auto', cursor: 'pointer' }}
            onClick={() => closeAdvancedSearch(false)}
          />
        </>
      )}
      {isDesktop && <CloseSearch closeAdvancedSearch={closeAdvancedSearch} />}
      <Typography
        variant={'h3'}
        margin='0 0 32px 0'
        sx={{ cursor: 'pointer' }}
        component='h2'
      >
        {Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.title}
      </Typography>
      <SearchFields />
      <Divider
        aria-label='hidden'
        sx={{
          borderColor: 'primary.shade_100',
          width: '100%',
          margin: isDesktop ? '32px 0' : '24px 0',
        }}
      />
      <DateFields />
      <Buttons
        dispatchReferrals={dispatchReferrals}
        closeAdvancedSearch={closeAdvancedSearch}
      />
    </Stack>
  );
};
